const TokenKey = 'b2b_token';
const potTokenKey = 'b2b_potTokenKey';

export function getToken() {
  return window.localStorage.getItem(TokenKey);
}

export function setToken(token) {
  window.localStorage.setItem("b2b_tokenTime", new Date());
  return window.localStorage.setItem(TokenKey, token);
}

export function getPotToken() {
  return window.localStorage.getItem(potTokenKey);
}

export function setPotToken(token) {
  return window.localStorage.setItem(potTokenKey, token);
}

export function removeToken() {
  return window.localStorage.removeItem(TokenKey);
}



// WEBPACK FOOTER //
// ./src/utils/auth.js